var exports = {
  "kL": "xdbfd91f1--0faaa2--container",
  "eE": "xdbfd91f1--0faaa2--container--mobile",
  "Qs": "xdbfd91f1--0faaa2--content",
  "Sl": "xdbfd91f1--0faaa2--image",
  "TJ": "xdbfd91f1--0faaa2--container--fat",
};

module.exports = exports;
